import MetadataSection from "./MetadataSection";

export default MetadataSection;



// WEBPACK FOOTER //
// ./src/components/QuickReview/MetadataSection/index.js